import React from 'react';
import { Container } from '@mui/material';
import { useAuthenticator } from '../../../../auth/AuthenticationContext';
import { ViewUnitContentProps } from '../../types/viewUnitContentProps';
import { SetpointProfileValues } from '../../../shared/setpoint-profile-values';
export const ViewUnitSetpointProfile = ({
  unit,
  property,
}: ViewUnitContentProps) => {
  const { user } = useAuthenticator();
  const id = unit?.setpointProfileId ?? property?.setpointProfileId;
  const selected = property?.assignableSetpointProfiles?.find(
    (profile) => profile._id === id,
  );
  return unit && property ? (
    <Container>
      <SetpointProfileValues
        profile={selected}
        units={user?.preferredUnits ?? 'F'}
      />
    </Container>
  ) : null;
};
